export default {
      id: "sync-usage",
      viewBox: "0 0 267.13 269.55",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#sync-usage",
      toString: function () {
        return this.url;
      }
    }